import * as React from 'react';
import { EditorState, SelectionState, Modifier } from 'draft-js';
import { QTYPES } from '@nexxt/common/types';
import { ROOT_REFERENCE } from '../../../../constants/defaultText';

export default class RootReference extends React.Component<any> {
    /**
     * Root Reference labeled by question type
     */
    getRootLabelByQuestionType = () => {
        switch (this.props.question.type) {
            case QTYPES.NPS:
                return 'NPS score';
            default:
                return 'ROOT QUESTION';
        }
    };
    getButtonLabelByQuestionType = () => {
        switch (this.props.question.type) {
            case QTYPES.NPS:
                return 'NPS Scale Reference';
            default:
                return 'Root Reference';
        }
    };
    addBreak = () => {
        const { editorState, onChange } = this.props;
        const contentState = editorState.getCurrentContent();
        const contentStateWithBreakEntity = contentState.createEntity(
            'ROOT_REFERENCE',
            'IMMUTABLE'
        );
        const entityKey = contentStateWithBreakEntity.getLastCreatedEntityKey();
        const newContentState = Modifier.replaceText(
            editorState.getCurrentContent(),
            editorState.getSelection(),
            this.getRootLabelByQuestionType(),
            null,
            entityKey
        );
        onChange(
            EditorState.push(editorState, newContentState, `apply-entity`)
        );
    };

    replaceText = (defaultText?) => {
        const { editorState, onChange, question } = this.props;
        const offset = defaultText.indexOf('{{');
        const contentState = editorState.getCurrentContent();

        const selectionState = editorState.getSelection();

        // we cant set the selection state directly because its immutable.
        // so make a copy
        const newSelection = selectionState.merge({
            anchorOffset: offset,
            focusOffset: offset + ROOT_REFERENCE.length
        }) as SelectionState;

        const contentStateWithBreakEntity = contentState.createEntity(
            'ROOT_REFERENCE',
            'IMMUTABLE'
        );
        const entityKey = contentStateWithBreakEntity.getLastCreatedEntityKey();
        const newContentState = Modifier.replaceText(
            editorState.getCurrentContent(),
            newSelection,
            this.getRootLabelByQuestionType(),
            null,
            entityKey
        );

        onChange(
            EditorState.push(editorState, newContentState, `apply-entity`)
        );
    };

    render() {
        return (
            <div className="answer--reference--container">
                <div className="rdw-option-wrapper" onClick={this.addBreak}>
                    <i className="nx nx-speech" />
                    <span>{this.getButtonLabelByQuestionType()}</span>
                    {/* ╠ */}
                </div>
            </div>
        );
    }
}
